module.exports = __webpack_public_path__ + "img/LF006-07.b9df8738.jpg";